import { render, staticRenderFns } from "./supplier-freight.vue?vue&type=template&id=9d5f8916&scoped=true&"
import script from "./supplier-freight.vue?vue&type=script&lang=js&"
export * from "./supplier-freight.vue?vue&type=script&lang=js&"
import style0 from "./supplier-freight.vue?vue&type=style&index=0&id=9d5f8916&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5f8916",
  null
  
)

export default component.exports